import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import NLS                  from "dashboard/dist/Core/NLS";
import Status               from "dashboard/dist/Core/Status";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import EditDialog           from "dashboard/dist/Components/EditDialog";
import DialogMessage        from "dashboard/dist/Components/DialogMessage";
import InputField           from "dashboard/dist/Components/InputField";

// Actions
import {
    fetchConversation, cancelConversation,
} from "Actions/Admin/Conversation/ConversationActions";



/**
 * The Conversation Cancel Dialog
 */
class ConversationCancel extends React.Component {
    // The Initial Data
    initialData = {
        conversationID  : 0,
        cancelledReason : "",
        cancelledNotice : 0,
    }

    // The Current State
    state = {
        loading : false,
        data    : { ...this.initialData },
        errors  : {},
    }



    /**
     * Get the Data when the Element ID changes
     * @param {Object} prevProps
     * @returns {Void}
     */
    componentDidUpdate(prevProps) {
        const { open, edition, elemID, elem, fetchConversation } = this.props;

        let loading = false;
        let data    = null;

        // Dialog Opens
        if (open && !prevProps.open) {
            data = { ...this.initialData };
            // Load new data
            if (elemID) {
                fetchConversation(elemID);
                loading = true;
            }

        // Data Updated
        } else if (prevProps.edition !== edition && elemID) {
            data = Utils.extend(this.initialData, elem);
        }

        // Set the State
        if (data) {
            this.setState({ data, loading, errors : {} });
        }
    }

    /**
     * Handles the Input Change
     * @param {String} name
     * @param {*}      value
     * @returns {Void}
     */
    handleChange = (name, value) => {
        this.setState({
            data   : { ...this.state.data,   [name] : value },
            errors : { ...this.state.errors, [name] : ""    },
        });
    }

    /**
     * Handles the Submit
     * @returns {Promise}
     */
    handleSubmit = async () => {
        const { cancelConversation, onSubmit } = this.props;
        const { data, loading                } = this.state;

        if (!loading) {
            this.setState({ loading : true, errors : {} });
            try {
                await cancelConversation(data);
                this.setState({ loading : false });
                onSubmit(Status.getID("CANCELLED"));
            } catch (errors) {
                this.setState({ loading : false, errors });
            }
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { elem, open, onClose   } = this.props;
        const { data, loading, errors } = this.state;

        return <EditDialog
            open={open}
            icon="cancel"
            title="CONVERSATIONS_CANCEL_TITLE"
            error={errors.form}
            onSubmit={this.handleSubmit}
            onClose={onClose}
            isLoading={loading}
            isNarrow
        >
            <DialogMessage
                variant="h3"
                html={NLS.format("CONVERSATIONS_CANCEL_TEXT", elem.description)}
            />
            <InputField
                name="cancelledReason"
                label="CONVERSATIONS_REASON"
                value={data.cancelledReason}
                error={errors.cancelledReason}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                type="toggle"
                name="cancelledNotice"
                label="CONVERSATIONS_NOTICE"
                value={data.cancelledNotice}
                onChange={this.handleChange}
            />
        </EditDialog>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchConversation  : PropTypes.func.isRequired,
        cancelConversation : PropTypes.func.isRequired,
        open               : PropTypes.bool.isRequired,
        onClose            : PropTypes.func.isRequired,
        onSubmit           : PropTypes.func.isRequired,
        edition            : PropTypes.number.isRequired,
        elem               : PropTypes.object.isRequired,
        elemID             : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            edition : state.conversation.edition,
            elem    : state.conversation.elem,
        };
    }
}

export default connect(ConversationCancel.mapStateToProps, {
    fetchConversation, cancelConversation,
})(ConversationCancel);
